import ResultContainer from "./components/ResultContainer";
import ResultText from "./components/ResultText";
import ResultTitle from "./components/ResultTitle";

export default { ResultContainer, ResultText, ResultTitle };
